import {
  ASSET_TYPE,
  BUILDER_TYPE,
  CONSTRUCTION_TYPE,
  FIELD_VALUES,
  FREQUENCY,
  GOVT_BENEFIT_TYPE,
  INCOME_TYPE,
  LIABILITY_TYPE,
} from '.';
import { FIELD_VALUE_LABELS } from './fieldValueLabels';

export const FHOG_OPTIONS = [
  { label: 'Yes', value: FIELD_VALUES.YES },
  { label: 'No', value: FIELD_VALUES.NO },
  { label: "Don't know", value: FIELD_VALUES.NOT_SURE },
];

export const FREQUENCY_OPTIONS = [
  { value: FREQUENCY.WEEKLY, label: 'Weekly' },
  { value: FREQUENCY.FORTNIGHTLY, label: 'Fortnightly' },
  { value: FREQUENCY.MONTHLY, label: 'Monthly' },
  { value: FREQUENCY.YEARLY, label: 'Yearly' },
];

export const FREQUENCY_EXPENSE_OPTIONS = [
  { value: FREQUENCY.WEEKLY, label: 'Weekly' },
  { value: FREQUENCY.FORTNIGHTLY, label: 'Fortnightly' },
  { value: FREQUENCY.MONTHLY, label: 'Monthly' },
  { value: FREQUENCY.QUARTERLY, label: 'Quarterly' },
  { value: FREQUENCY.YEARLY, label: 'Yearly' },
];

export const MONTHS_OPTIONS = [
  { value: '0', label: '0 Months' },
  { value: '1', label: '1 Month' },
  { value: '2', label: '2 Months' },
  { value: '3', label: '3 Months' },
  { value: '4', label: '4 Months' },
  { value: '5', label: '5 Months' },
  { value: '6', label: '6 Months' },
  { value: '7', label: '7 Months' },
  { value: '8', label: '8 Months' },
  { value: '9', label: '9 Months' },
  { value: '10', label: '10 Months' },
  { value: '11', label: '11 Months' },
];

export const PROPERTY_STATUS_OPTIONS = [
  {
    label: 'Newly built, or off the plan',
    value: FIELD_VALUES.NEW_BUILDING,
  },
  {
    label: 'Existing property',
    value: FIELD_VALUES.ESTABLISHED,
  },
  { label: 'Vacant land to build on', value: FIELD_VALUES.VACANT_LAND },
];

export const PROPERTY_TYPE_OPTIONS = [
  {
    label: 'Apartment',
    options: [
      { label: 'Apartment less than 50m2', value: FIELD_VALUES.UNIT_LESS_THAN_50M2 },
      { label: 'Apartment more than 50m2', value: FIELD_VALUES.UNIT_MORE_THAN_50M2 },
      { label: 'Duplex', value: FIELD_VALUES.DUPLEX },
      { label: 'Serviced Apartment', value: FIELD_VALUES.SERVICED_APARTMENT },
      { label: 'Student Accommodation', value: FIELD_VALUES.STUDENT_ACCOMMODATION },
      { label: 'Studio', value: FIELD_VALUES.STUDIO },
      { label: 'Villa', value: FIELD_VALUES.VILLA },
      { label: 'Warehouse Apartment', value: FIELD_VALUES.WAREHOUSE_APARTMENT },
    ],
  },
  {
    label: 'House',
    options: [
      { label: 'Fully Detached House', value: FIELD_VALUES.FULLY_DETACHED_HOUSE },
      { label: 'Kit Home', value: FIELD_VALUES.KIT_HOME },
      { label: 'Multi-Dwelling Single Title', value: FIELD_VALUES.MULTI_DWELLING_SINGLE_TITLE },
      { label: 'Property over 10 HA', value: FIELD_VALUES.PROPERTY_OVER_10HA },
      { label: 'Semi-detached house', value: FIELD_VALUES.SEMI_DETACHED_HOUSE },
      { label: 'Terrace', value: FIELD_VALUES.TERRACE },
      { label: 'Townhouse', value: FIELD_VALUES.TOWNHOUSE },
    ],
  },
  {
    label: 'Land',
    options: [{ label: 'Land', value: FIELD_VALUES.LAND }],
  },
];

export const REPAYMENT_TYPE_OPTIONS = [
  { value: FIELD_VALUES.PRINCIPAL_AND_INTEREST, label: 'Principal and interest' },
  { value: FIELD_VALUES.INTEREST_ONLY, label: 'Interest only' },
];

export const INTEREST_TYPE_OPTIONS = [
  { value: FIELD_VALUES.FIXED_RATE, label: 'Yes' },
  { value: FIELD_VALUES.VARIABLE, label: 'No' },
];

export const STATE_OPTIONS = [
  { value: 'ACT', label: 'ACT' },
  { value: 'NSW', label: 'NSW' },
  { value: 'NT', label: 'NT' },
  { value: 'QLD', label: 'QLD' },
  { value: 'SA', label: 'SA' },
  { value: 'TAS', label: 'TAS' },
  { value: 'VIC', label: 'VIC' },
  { value: 'WA', label: 'WA' },
];

export const YES_NO_OPTIONS = [
  { label: 'Yes', value: FIELD_VALUES.TRUE },
  { label: 'No', value: FIELD_VALUES.FALSE },
];

export const BORROWING_POWER_SITUATION_OPTIONS = [
  { label: 'Actively looking or just made an offer', value: FIELD_VALUES.OFFER_MADE },
  { label: 'Plan to buy in the next 6 months', value: FIELD_VALUES.BUYING_SOON },
  { label: 'Just exploring my borrowing power options', value: FIELD_VALUES.EXPLORING_OPTIONS },
];

export const BUYING_SITUATION_OPTIONS = [
  { label: 'Exchanged contracts', value: FIELD_VALUES.CONTRACTS_EXCHANGED },
  { label: 'Actively looking or just made an offer', value: FIELD_VALUES.OFFER_MADE },
  { label: 'Plan to buy in the next 6 months', value: FIELD_VALUES.BUYING_SOON },
  { label: 'Just exploring options', value: FIELD_VALUES.EXPLORING_OPTIONS },
];

export const CREDIT_STATUS_OPTIONS = [
  { label: 'Excellent - No Issues', value: FIELD_VALUES.EXCELLENT },
  { label: 'Average - Paid default', value: FIELD_VALUES.AVERAGE },
  { label: "Fair - Let's talk", value: FIELD_VALUES.FAIR },
  { label: "I don't know", value: FIELD_VALUES.UNKNOWN },
];

export const EMPLOYMENT_BASIS_OPTIONS = [
  { label: 'Full time', value: FIELD_VALUES.FULL_TIME },
  { label: 'Part time', value: FIELD_VALUES.PART_TIME },
  { label: 'Casual', value: FIELD_VALUES.CASUAL },
  { label: 'Contractor', value: FIELD_VALUES.CONTRACTOR },
];

export const EMPLOYMENT_BASIS_WITH_MATERNITY_LEAVE_OPTIONS = [
  ...EMPLOYMENT_BASIS_OPTIONS,
  { label: 'Currently on Maternity Leave', value: FIELD_VALUES.MATERNITY_LEAVE },
];

export const BUSINESS_STRUCTURE_OPTIONS = [
  { label: 'Company', value: FIELD_VALUES.COMPANY },
  { label: 'Partnership', value: FIELD_VALUES.PARTNERSHIP },
  { label: 'Sole trader', value: FIELD_VALUES.SOLE_TRADER },
  { label: 'Trust', value: FIELD_VALUES.TRUST },
];

export const SECONDARY_EMPLOYMENT_TYPE_OPTIONS = [
  { label: 'Employee', value: FIELD_VALUES.EMPLOYEE },
  { label: 'Self-employed', value: FIELD_VALUES.SELF_EMPLOYED },
];

export const PRIMARY_EMPLOYMENT_TYPE_OPTIONS = [
  ...SECONDARY_EMPLOYMENT_TYPE_OPTIONS,
  { label: 'Not working', value: FIELD_VALUES.NOT_WORKING },
];

export const PREVIOUS_EMPLOYMENT_TYPE_OPTIONS = [
  ...SECONDARY_EMPLOYMENT_TYPE_OPTIONS,
  { label: 'Not working', value: FIELD_VALUES.NOT_WORKING },
];

export const EMPLOYMENT_HISTORY_SECONDARY_ROLE_OPTIONS = [
  { label: 'Current - Secondary', value: FIELD_VALUES.SECONDARY },
  { label: 'Previous', value: FIELD_VALUES.PREVIOUS },
];

export const EMPLOYMENT_HISTORY_ROLE_OPTIONS = [
  { label: 'Current - Primary', value: FIELD_VALUES.PRIMARY },
  ...EMPLOYMENT_HISTORY_SECONDARY_ROLE_OPTIONS,
];

export const EMPLOYMENT_HISTORY_TYPE_OPTIONS = [
  ...SECONDARY_EMPLOYMENT_TYPE_OPTIONS,
  { label: 'Other', value: FIELD_VALUES.NOT_WORKING },
];

export const EMPLOYMENT_TYPE_EDITABLE_OPTIONS = [
  ...SECONDARY_EMPLOYMENT_TYPE_OPTIONS,
  { label: 'Self-Employed (low doc)', value: FIELD_VALUES.SELF_EMPLOYED_LOW_DOC },
  { label: 'Other', value: FIELD_VALUES.NOT_WORKING },
];

export const EMPLOYMENT_TYPE_FUNNEL_TWO_OPTIONS = [
  ...SECONDARY_EMPLOYMENT_TYPE_OPTIONS,
  { label: 'Other', value: FIELD_VALUES.NOT_WORKING },
];

export const HOW_CAN_WE_HELP_OPTIONS = [
  { label: 'Get approved for a home loan', value: FIELD_VALUES.LOAN_APPROVAL },
  { label: "See home loans I'm eligible for", value: FIELD_VALUES.LOAN_ELIGIBILITY },
  { label: 'Check how much I can borrow', value: FIELD_VALUES.LOAN_AFFORDABILITY },
];

export const PAYMENT_TYPE_OPTIONS = [
  { label: 'Principal and Interest', value: FIELD_VALUES.PRINCIPAL_AND_INTEREST },
  { label: 'Interest only', value: FIELD_VALUES.INTEREST_ONLY },
  { label: 'Still deciding', value: FIELD_VALUES.STILL_DECIDING },
];

export const PROPERTY_USE_OPTIONS = [
  { label: 'Owner occupied', value: FIELD_VALUES.OWNER_OCCUPIED },
  { label: 'Investment', value: FIELD_VALUES.INVESTMENT },
];

export const PROPERTY_USE_OPTIONS_REFINANCE = [
  { label: 'Owner occupied', value: FIELD_VALUES.OWNER_OCCUPIED },
  { label: 'Investment', value: FIELD_VALUES.INVESTMENT },
];

export const PROPERTY_USE_OPTIONS_OTHER_PROPERTY_ASSET = [
  { label: 'Owner occupied', value: FIELD_VALUES.OWNER_OCCUPIED },
  { label: 'Investment', value: FIELD_VALUES.INVESTMENT },
  { label: 'Commercial', value: FIELD_VALUES.COMMERCIAL },
];

export const PROPERTY_INVOLVEMENT_OPTIONS = [
  { label: 'New purchase', value: FIELD_VALUES.NEW_PURCHASE },
  { label: 'Refinance', value: FIELD_VALUES.REFINANCE },
  { label: 'Security', value: FIELD_VALUES.SECURITY_PROPERTY },
];

export const REFINANCING_REASONS_OPTIONS_PRE_NEW_CONSTRUCTION = [
  { label: 'Decrease repayments', value: FIELD_VALUES.DECREASE_REPAYMENTS },
  { label: 'Pay off loan faster', value: FIELD_VALUES.FASTER_PAYOFF },
  { label: 'Consolidate debt / get cash out', value: FIELD_VALUES.CONSOLIDATE_CASHOUT },
  { label: 'Knockdown rebuild / build a property', value: FIELD_VALUES.CONSTRUCTION },
];

export const REFINANCING_REASONS_OPTIONS = [
  { label: 'Decrease repayments', value: FIELD_VALUES.DECREASE_REPAYMENTS },
  { label: 'Pay off loan faster', value: FIELD_VALUES.FASTER_PAYOFF },
  { label: 'Consolidate debt / get cash out', value: FIELD_VALUES.CONSOLIDATE_CASHOUT },
  { label: 'Construct on my land or property', value: FIELD_VALUES.CONSTRUCTION },
];

export const RELATIONSHIP_STATUS_OPTIONS = [
  { label: 'Married', value: FIELD_VALUES.MARRIED, allowDropdown: true },
  { label: 'Single', value: FIELD_VALUES.SINGLE, allowDropdown: false },
  { label: 'De facto', value: FIELD_VALUES.DE_FACTO, allowDropdown: true },
  { label: 'Divorced', value: FIELD_VALUES.DIVORCED, allowDropdown: false },
  { label: "It's complicated", value: FIELD_VALUES.UNKNOWN, allowDropdown: false, labelAlt: 'Unknown' },
];

export const RESIDENCY_STATUS_OPTIONS = [
  { label: 'Australian citizen', value: FIELD_VALUES.AUSTRALIAN_CITIZEN },
  { label: 'Permanent resident', value: FIELD_VALUES.PERMANENT_RESIDENT },
  { label: 'Temporary resident', value: FIELD_VALUES.TEMPORARY_RESIDENT },
  { label: "It's complicated", value: FIELD_VALUES.UNKNOWN, labelAlt: 'Non resident' },
];

export const HOUSING_STATUS_OPTIONS = [
  { label: 'Own home mortgage', value: FIELD_VALUES.OWN_HOME_MORTGAGE },
  { label: 'Own home outright', value: FIELD_VALUES.OWN_HOME },
  { label: 'Renting', value: FIELD_VALUES.RENTING },
  { label: 'Boarding', value: FIELD_VALUES.BOARDING },
  { label: 'Live with parents or family', value: FIELD_VALUES.WITH_PARENTS },
  { label: 'Other', value: FIELD_VALUES.HOUSING_STATUS_OTHER },
];

export const URGENCY_OPTIONS = [
  { label: "It's urgent", value: FIELD_VALUES.URGENT },
  { label: 'Just investigating options', value: FIELD_VALUES.NOT_URGENT },
];

export const PRIMARY_PURPOSE_OPTIONS = [
  { label: 'Refinance', value: FIELD_VALUES.REFINANCE },
  { label: 'New purchase', value: FIELD_VALUES.NEW_PURCHASE },
];

export const TITLE_OPTIONS = [
  { label: 'Mr', value: FIELD_VALUES.MR },
  { label: 'Mrs', value: FIELD_VALUES.MRS },
  { label: 'Miss', value: FIELD_VALUES.MISS },
  { label: 'Ms', value: FIELD_VALUES.MS },
  { label: 'Dr', value: FIELD_VALUES.DR },
];

export const ADDITIONAL_PROPERTY_USAGES_OPTIONS = [
  { label: 'I want to buy a home', value: FIELD_VALUES.TRUE },
  { label: 'I want to refinance', value: FIELD_VALUES.FALSE },
];

export const PROPERTY_ASSET_TYPE_OPTIONS = [
  { label: 'Refinance', value: FIELD_VALUES.REFINANCE },
  { label: 'New purchase', value: FIELD_VALUES.NEW_PURCHASE },
  { label: 'Security property', value: FIELD_VALUES.SECURITY_PROPERTY },
  { label: 'Other property asset', value: FIELD_VALUES.OTHER },
];

export const CREDIT_CARD_TYPE_OPTIONS = [
  { label: 'Credit Card', value: FIELD_VALUES.CREDIT_CARD },
  { label: 'Store Card', value: FIELD_VALUES.STORE_CARD },
];

export const MANUFACTURER_OPTIONS = [
  { label: 'Abarth', value: 'Abarth' },
  { label: 'AC', value: 'AC' },
  { label: 'Alfa Romeo', value: 'Alfa Romeo' },
  { label: 'Alpina', value: 'Alpina' },
  { label: 'Alpine-Renault', value: 'Alpine-Renault' },
  { label: 'Alvis', value: 'Alvis' },
  { label: 'AM General', value: 'AM General' },
  { label: 'Ariel', value: 'Ariel' },
  { label: 'Armstrong Siddeley', value: 'Armstrong Siddeley' },
  { label: 'Aston Martin', value: 'Aston Martin' },
  { label: 'Audi', value: 'Audi' },
  { label: 'Austin', value: 'Austin' },
  { label: 'Austin Healey', value: 'Austin Healey' },
  { label: 'Bentley', value: 'Bentley' },
  { label: 'BMW', value: 'BMW' },
  { label: 'Bolwell', value: 'Bolwell' },
  { label: 'Bond', value: 'Bond' },
  { label: 'Bristol', value: 'Bristol' },
  { label: 'Bufori', value: 'Bufori' },
  { label: 'Buick', value: 'Buick' },
  { label: 'Bullet', value: 'Bullet' },
  { label: 'BYD', value: 'BYD' },
  { label: 'Cadillac', value: 'Cadillac' },
  { label: 'Caterham', value: 'Caterham' },
  { label: 'Chery', value: 'Chery' },
  { label: 'Chevrolet', value: 'Chevrolet' },
  { label: 'Chrysler', value: 'Chrysler' },
  { label: 'Citroen', value: 'Citroen' },
  { label: 'Cupra', value: 'Cupra' },
  { label: 'Custom', value: 'Custom' },
  { label: 'Daewoo', value: 'Daewoo' },
  { label: 'Daihatsu', value: 'Daihatsu' },
  { label: 'Daimler', value: 'Daimler' },
  { label: 'Datsun', value: 'Datsun' },
  { label: 'De Tomaso', value: 'De Tomaso' },
  { label: 'DeSoto', value: 'DeSoto' },
  { label: 'Dodge', value: 'Dodge' },
  { label: 'Durant', value: 'Durant' },
  { label: 'Elfin', value: 'Elfin' },
  { label: 'Eunos', value: 'Eunos' },
  { label: 'Ferrari', value: 'Ferrari' },
  { label: 'Fiat', value: 'Fiat' },
  { label: 'Ford', value: 'Ford' },
  { label: 'Ford Performance Vehicles', value: 'Ford Performance Vehicles' },
  { label: 'Foton', value: 'Foton' },
  { label: 'Fuso', value: 'Fuso' },
  { label: 'Geely', value: 'Geely' },
  { label: 'Genesis', value: 'Genesis' },
  { label: 'GMC', value: 'GMC' },
  { label: 'Goliath', value: 'Goliath' },
  { label: 'Great Wall', value: 'Great Wall' },
  { label: 'GWM', value: 'GWM' },
  { label: 'Haval', value: 'Haval' },
  { label: 'HDT', value: 'HDT' },
  { label: 'Higer', value: 'Higer' },
  { label: 'Hillman', value: 'Hillman' },
  { label: 'Hino', value: 'Hino' },
  { label: 'Holden', value: 'Holden' },
  { label: 'Holden Special Vehicles', value: 'Holden Special Vehicles' },
  { label: 'Honda', value: 'Honda' },
  { label: 'Humber', value: 'Humber' },
  { label: 'Hummer', value: 'Hummer' },
  { label: 'Hyundai', value: 'Hyundai' },
  { label: 'Infiniti', value: 'Infiniti' },
  { label: 'International', value: 'International' },
  { label: 'Isuzu', value: 'Isuzu' },
  { label: 'Iveco', value: 'Iveco' },
  { label: 'Jaguar', value: 'Jaguar' },
  { label: 'Jeep', value: 'Jeep' },
  { label: 'Jensen', value: 'Jensen' },
  { label: 'JMC', value: 'JMC' },
  { label: 'Kia', value: 'Kia' },
  { label: 'KTM', value: 'KTM' },
  { label: 'Lada', value: 'Lada' },
  { label: 'Lamborghini', value: 'Lamborghini' },
  { label: 'Lancia', value: 'Lancia' },
  { label: 'Land Rover', value: 'Land Rover' },
  { label: 'LDV', value: 'LDV' },
  { label: 'Leapmotor', value: 'Leapmotor' },
  { label: 'Lexus', value: 'Lexus' },
  { label: 'Leyland', value: 'Leyland' },
  { label: 'Lincoln', value: 'Lincoln' },
  { label: 'Lotus', value: 'Lotus' },
  { label: 'Mack', value: 'Mack' },
  { label: 'Mahindra', value: 'Mahindra' },
  { label: 'Maserati', value: 'Maserati' },
  { label: 'Matra', value: 'Matra' },
  { label: 'Mazda', value: 'Mazda' },
  { label: 'McLaren', value: 'McLaren' },
  { label: 'Mercedes-Benz', value: 'Mercedes-Benz' },
  { label: 'Mercury', value: 'Mercury' },
  { label: 'MG', value: 'MG' },
  { label: 'MINI', value: 'MINI' },
  { label: 'Mitsubishi', value: 'Mitsubishi' },
  { label: 'Morgan', value: 'Morgan' },
  { label: 'Morris', value: 'Morris' },
  { label: 'Nissan', value: 'Nissan' },
  { label: 'Oldsmobile', value: 'Oldsmobile' },
  { label: 'Opel', value: 'Opel' },
  { label: 'Packard', value: 'Packard' },
  { label: 'Panther', value: 'Panther' },
  { label: 'Peugeot', value: 'Peugeot' },
  { label: 'Plymouth', value: 'Plymouth' },
  { label: 'Polestar', value: 'Polestar' },
  { label: 'Pontiac', value: 'Pontiac' },
  { label: 'Porsche', value: 'Porsche' },
  { label: 'Proton', value: 'Proton' },
  { label: 'Purvis', value: 'Purvis' },
  { label: 'RAM', value: 'RAM' },
  { label: 'Renault', value: 'Renault' },
  { label: 'Riley', value: 'Riley' },
  { label: 'Robnell', value: 'Robnell' },
  { label: 'Rolls-Royce', value: 'Rolls-Royce' },
  { label: 'Rover', value: 'Rover' },
  { label: 'Saab', value: 'Saab' },
  { label: 'Seat', value: 'Seat' },
  { label: 'SKODA', value: 'SKODA' },
  { label: 'smart', value: 'smart' },
  { label: 'SsangYong', value: 'SsangYong' },
  { label: 'Steyr-Puch', value: 'Steyr-Puch' },
  { label: 'Studebaker', value: 'Studebaker' },
  { label: 'Stutz', value: 'Stutz' },
  { label: 'Subaru', value: 'Subaru' },
  { label: 'Sunbeam', value: 'Sunbeam' },
  { label: 'Suzuki', value: 'Suzuki' },
  { label: 'Tata', value: 'Tata' },
  { label: 'Tesla', value: 'Tesla' },
  { label: 'Toyota', value: 'Toyota' },
  { label: 'TRD', value: 'TRD' },
  { label: 'Triumph', value: 'Triumph' },
  { label: 'TVR', value: 'TVR' },
  { label: 'U.D.', value: 'U.D.' },
  { label: 'Ultima', value: 'Ultima' },
  { label: 'Vanden Plas', value: 'Vanden Plas' },
  { label: 'Vauxhall', value: 'Vauxhall' },
  { label: 'Volkswagen', value: 'Volkswagen' },
  { label: 'Volvo', value: 'Volvo' },
  { label: 'Westfield', value: 'Westfield' },
  { label: 'Willys', value: 'Willys' },
  { label: 'Wolseley', value: 'Wolseley' },
  { label: 'ZX Auto', value: 'ZX Auto' },
];

export const ADDITIONAL_ASSET_TYPE_OPTIONS = [
  { label: 'Gifts', value: ASSET_TYPE.GIFTS },
  { label: 'Home contents', value: ASSET_TYPE.HOME_CONTENTS },
  { label: 'Managed funds', value: ASSET_TYPE.MANAGED_FUNDS },
  { label: 'Shares', value: ASSET_TYPE.SHARES },
  { label: 'Superannuation', value: ASSET_TYPE.SUPERANNUATION },
  { label: 'Term deposit', value: ASSET_TYPE.TERM_DEPOSIT },
  { label: 'Other', value: ASSET_TYPE.OTHER_ASSET },
];
export const ASSET_TYPE_OPTIONS = [
  { label: 'Property', value: ASSET_TYPE.PROPERTY },
  { label: 'Vehicle', value: ASSET_TYPE.VEHICLE },
  { label: 'Savings account', value: ASSET_TYPE.SAVING_CHECK_ACCOUNT },
  ...ADDITIONAL_ASSET_TYPE_OPTIONS,
];

export const OTHER_LIABILITY_TYPE_OPTIONS = [
  {
    value: LIABILITY_TYPE.HIRE_PURCHASE,
    label: 'Hire purchase',
  },
  {
    value: LIABILITY_TYPE.LEASE,
    label: 'Lease',
  },
  {
    value: LIABILITY_TYPE.TAX_DEBT,
    label: 'Tax debt',
  },
  {
    value: LIABILITY_TYPE.LINE_OF_CREDIT,
    label: 'Line of credit',
  },
  {
    value: LIABILITY_TYPE.OVERDRAFT,
    label: 'Overdraft',
  },
  {
    value: LIABILITY_TYPE.HELP_HECS_DEBT,
    label: 'HELP/HECS debt',
  },
  {
    value: LIABILITY_TYPE.OTHER,
    label: 'Other',
  },
];

export const LIABILITY_TYPE_OPTIONS = [
  {
    value: LIABILITY_TYPE.HOME_LOAN,
    label: 'Home loan',
  },
  {
    value: LIABILITY_TYPE.CAR_LOAN,
    label: 'Car loan',
  },
  {
    value: LIABILITY_TYPE.PERSONAL_LOAN,
    label: 'Personal loan',
  },
  {
    value: LIABILITY_TYPE.CREDIT_CARD,
    label: 'Credit card',
  },
  {
    value: LIABILITY_TYPE.STORE_CARD,
    label: 'Store card',
  },
  ...OTHER_LIABILITY_TYPE_OPTIONS,
];

export const LIABILITY_TYPE_OPTIONS_TO_INCLUDE = [
  LIABILITY_TYPE.SHORT_TERM_FINANCE,
  LIABILITY_TYPE.LEASE,
  LIABILITY_TYPE.HIRE_PURCHASE,
  LIABILITY_TYPE.TAX_DEBT,
  LIABILITY_TYPE.LINE_OF_CREDIT,
  LIABILITY_TYPE.OVERDRAFT,
  LIABILITY_TYPE.HELP_HECS_DEBT,
  LIABILITY_TYPE.OTHER,
];

export const DEFAULT_INCOME_TYPES_OPTIONS = [
  { label: 'Bonus', value: INCOME_TYPE.PAYG_BONUS_INCOME },
  { label: 'Commission', value: INCOME_TYPE.PAYG_COMMISSION_INCOME },
  { label: 'Overtime', value: INCOME_TYPE.PAYG_OVERTIME_INCOME },
  { label: 'Car allowance', value: INCOME_TYPE.PAYG_CAR_ALLOWANCE },
  { label: 'Work allowance (taxed)', value: INCOME_TYPE.PAYG_ALLOWANCES_TAXED },
  { label: 'Work allowance (non-taxed)', value: INCOME_TYPE.PAYG_ALLOWANCES_NOT_TAXED },
  { label: 'Company car', value: INCOME_TYPE.PAYG_COMPANY_CAR },
  { label: 'Non-voluntary deductions (pre-tax)', value: INCOME_TYPE.PAYG_NON_VOLUNTARY_DEDUCTIONS_PRE_TAX },
  { label: 'Salary sacrifice', value: INCOME_TYPE.PAYG_SALARY_SACRIFICE },
];
export const PAYG_INCOME_TYPE_OPTIONS = [
  { label: 'PAYG base salary', value: INCOME_TYPE.PAYG_BASE_SALARY },
  ...DEFAULT_INCOME_TYPES_OPTIONS,
];
export const SELF_EMPLOYED_INCOME_TYPE_OPTIONS = [
  { label: 'Income or profit before tax', value: INCOME_TYPE.SELF_EMPLOYED_BUSINESS_INCOME },
];

export const ADDITIONAL_INCOME_TYPE_OPTIONS = [
  { label: 'Investment income', value: INCOME_TYPE.INVESTMENT_INCOME },
  { label: 'Government benefit', value: INCOME_TYPE.GOVT_BENEFIT },
  { label: 'Foreign income', value: INCOME_TYPE.FOREIGN_INCOME },
  { label: 'Receiving child maintenance', value: INCOME_TYPE.CHILD_MAINTENANCE },
  { label: 'Workers compensation', value: INCOME_TYPE.WORKERS_COMPENSATION },
  { label: 'Super/annuity/private pension', value: INCOME_TYPE.SUPER_ANNUITY_PENSION },
  { label: 'Other', value: INCOME_TYPE.OTHER_INCOME },
];

export const INCOME_TYPE_OPTIONS = [
  ...DEFAULT_INCOME_TYPES_OPTIONS,
  { label: 'Base salary', value: INCOME_TYPE.PAYG_BASE_SALARY },
  { label: 'Self-employed business income', value: INCOME_TYPE.SELF_EMPLOYED_BUSINESS_INCOME },
  { label: 'Rental income', value: INCOME_TYPE.RENTAL_INCOME },
  ...ADDITIONAL_INCOME_TYPE_OPTIONS,
];

export const GOVT_BENEFIT_TYPE_OPTIONS = [
  { label: 'Age pension', value: GOVT_BENEFIT_TYPE.AGE_PENSION },
  { label: 'Disability support pension', value: GOVT_BENEFIT_TYPE.DISABILITY_SUPPORT_PENSION },
  { label: 'Family tax A/B', value: GOVT_BENEFIT_TYPE.FAMILY_TAX },
];

export const CONSTRUCTION_TYPE_OPTIONS = [
  { label: FIELD_VALUE_LABELS[CONSTRUCTION_TYPE.BUILD_A_PROPERTY], value: CONSTRUCTION_TYPE.BUILD_A_PROPERTY },
  { label: FIELD_VALUE_LABELS[CONSTRUCTION_TYPE.KNOCKDOWN_REBUILD], value: CONSTRUCTION_TYPE.KNOCKDOWN_REBUILD },
  {
    label: FIELD_VALUE_LABELS[CONSTRUCTION_TYPE.STRUCTURAL_RENOVATIONS],
    value: CONSTRUCTION_TYPE.STRUCTURAL_RENOVATIONS,
  },
];

export const BUILDER_TYPE_OPTIONS = [
  { label: FIELD_VALUE_LABELS[BUILDER_TYPE.LICENSED_BUILDER], value: BUILDER_TYPE.LICENSED_BUILDER },
  { label: FIELD_VALUE_LABELS[BUILDER_TYPE.OWNER_BUILDER], value: BUILDER_TYPE.OWNER_BUILDER },
];

// this maps to {applicant.applicantType} in server data
export const APPLICANT_ROLE_OPTIONS = [
  { label: 'Borrower', value: FIELD_VALUES.BORROWER },
  { label: 'Guarantor', value: FIELD_VALUES.GUARANTOR },
];

export const APPLICANT_TYPE_OPTIONS = [
  { label: FIELD_VALUE_LABELS[FIELD_VALUES.PERSON], value: FIELD_VALUES.PERSON },
  { label: FIELD_VALUE_LABELS[FIELD_VALUES.COMPANY], value: FIELD_VALUES.COMPANY },
  { label: FIELD_VALUE_LABELS[FIELD_VALUES.TRUST], value: FIELD_VALUES.TRUST },
];

export const APPLICANT_TYPE_OPTIONS_NON_TRUST = [
  { label: FIELD_VALUE_LABELS[FIELD_VALUES.PERSON], value: FIELD_VALUES.PERSON },
  { label: FIELD_VALUE_LABELS[FIELD_VALUES.COMPANY], value: FIELD_VALUES.COMPANY },
];

export const TRUST_TYPE_OPTIONS = [
  { label: 'Cash management', value: FIELD_VALUES.CASH_MANAGEMENT_TRUST },
  { label: 'Discretionary', value: FIELD_VALUES.DISCRETIONARY_TRUST },
  { label: 'Fixed', value: FIELD_VALUES.FIXED },
  { label: 'Hybrid', value: FIELD_VALUES.HYBRID },
  { label: 'Superannuation', value: FIELD_VALUES.SUPERANNUATION_TRUSTS },
  { label: 'Unit', value: FIELD_VALUES.UNIT },
  { label: 'Simple/Bare', value: FIELD_VALUES.SIMPLE_OR_BARE },
  { label: 'Other', value: FIELD_VALUES.OTHER },
];

export const PREFERRED_REPAYMENT_METHOD_OPTIONS = [
  { label: 'Direct debit - new account', value: FIELD_VALUES.DIRECT_DEBIT_NEW_ACCOUNT },
  { label: 'Direct debit - existing account', value: FIELD_VALUES.DIRECT_DEBIT_EXISTING_ACCOUNT },
  { label: 'Direct credit', value: FIELD_VALUES.DIRECT_CREDIT },
  { label: 'Manual repayments', value: FIELD_VALUES.MANUAL_REPAYMENTS },
];

export const PREFERRED_REPAYMENT_FREQUENCY_OPTIONS = [
  { label: 'Weekly', value: FREQUENCY.WEEKLY },
  { label: 'Fortnightly', value: FREQUENCY.FORTNIGHTLY },
  { label: 'Monthly', value: FREQUENCY.MONTHLY },
];

export const CONVEYANCING_OPTIONS = [
  { label: 'Yes, proceed with referral', value: FIELD_VALUES.YES },
  { label: 'Unsure, need to discuss with the customer', value: FIELD_VALUES.NOT_SURE },
  { label: 'No, customer has a conveyancer', value: FIELD_VALUES.NO },
];
